export enum EOsSystem {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
}

export enum ECheckoutPlatform {
  DESKTOP = 'CHECKOUT_DESKTOP',
  IOS = 'CHECKOUT_IOS',
  ANDROID = 'CHECKOUT_ANDROID',
}

export enum EBrowsersName {
  FIREFOX = 'Firefox',
  CHROME = 'Chrome',
  SAFARI = 'Safari',
  EDGE = 'Edge',
  OPERA = 'Opera',
}
